import log from 'salvo-lite/log'

class LoginRegister {
    constructor (theme, elem) {
        this.theme = theme
        this.elem = elem
        this.loginform = this.elem.querySelector('#customer_login')
        this.loginbtn = this.loginform.querySelector('.btn')
        this.newcust = this.elem.querySelector('#create_customer')
        this.newcustbtn = this.newcust.querySelector('.btn')
        this.forgotpword = this.elem.querySelector('.login-register__login__forgot')
        this.forgotbtn = this.forgotpword.querySelector('.btn')
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        this.loginbtn.addEventListener('click', e => {
            localStorage.setItem('form', 'login')
        })
        this.newcustbtn.addEventListener('click', e => {
            localStorage.setItem('form', 'cust')
        })
        this.forgotbtn.addEventListener('click', e => {
            localStorage.setItem('form', 'forgot')
        })

        let form = localStorage.getItem('form')
        if (form != null) {
            if (form === 'login') {
                let error = this.loginform.querySelector('.errors')
                let inputs = this.loginform.querySelectorAll('.text-box')
                error.classList.add('error')
                // console.log(inputs)
                for (var l = 0; l < inputs.length; l++) {
                    inputs[l].classList.add('errorbox')
                }
                localStorage.removeItem('form')
            }
            if (form === 'cust') {
                let error = this.newcust.querySelector('.errors')
                let inputs = this.newcust.querySelectorAll('.text-box')
                error.classList.add('error')
                for (var c = 0; c < inputs.length; c++) {
                    inputs[c].classList.add('errorbox')
                }
                localStorage.removeItem('form')
            }
            if (form === 'forgot') {
                let error = this.forgotpword.querySelector('.errors')
                let inputs = this.forgotpword.querySelectorAll('.text-box')
                error.classList.add('error')
                for (var p = 0; p < inputs.length; p++) {
                    inputs[p].classList.add('errorbox')
                }
                localStorage.removeItem('form')
            }
        }
    }
}
export default LoginRegister



// WEBPACK FOOTER //
// ./src/resources/scripts/components/LoginRegister.js